{
  "03d15d0c-e7ae-4383-b942-bef5af32b9d2": {
    "has_axis": [
      "03d15d0c-e7ae-4383-b942-bef5af32b9d2_bottom",
      "03d15d0c-e7ae-4383-b942-bef5af32b9d2_left",
      "03d15d0c-e7ae-4383-b942-bef5af32b9d2_right",
      "03d15d0c-e7ae-4383-b942-bef5af32b9d2_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "03d15d0c-e7ae-4383-b942-bef5af32b9d2_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "03d15d0c-e7ae-4383-b942-bef5af32b9d2_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "03d15d0c-e7ae-4383-b942-bef5af32b9d2_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "03d15d0c-e7ae-4383-b942-bef5af32b9d2_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "061bbcd0-e9c1-4988-a030-5f21b0570f76": {
    "has_axis": [
      "061bbcd0-e9c1-4988-a030-5f21b0570f76_bottom",
      "061bbcd0-e9c1-4988-a030-5f21b0570f76_left",
      "061bbcd0-e9c1-4988-a030-5f21b0570f76_right",
      "061bbcd0-e9c1-4988-a030-5f21b0570f76_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "061bbcd0-e9c1-4988-a030-5f21b0570f76_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom"
    ]
  },
  "061bbcd0-e9c1-4988-a030-5f21b0570f76_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "061bbcd0-e9c1-4988-a030-5f21b0570f76_right": {
    "is_limited_by": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_right"
    ]
  },
  "061bbcd0-e9c1-4988-a030-5f21b0570f76_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "062e6859-d511-484c-bac3-388fccb01635": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "062e6859-d511-484c-bac3-388fccb01635_bottom",
      "062e6859-d511-484c-bac3-388fccb01635_left",
      "062e6859-d511-484c-bac3-388fccb01635_right",
      "062e6859-d511-484c-bac3-388fccb01635_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "062e6859-d511-484c-bac3-388fccb01635_bottom": {
    "is_limited_by": [
      "731d57c9-7588-4ca3-a019-5618a436794a_bottom"
    ]
  },
  "062e6859-d511-484c-bac3-388fccb01635_left": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_left"
    ]
  },
  "062e6859-d511-484c-bac3-388fccb01635_right": {
    "is_limited_by": [
      "731d57c9-7588-4ca3-a019-5618a436794a_right"
    ]
  },
  "062e6859-d511-484c-bac3-388fccb01635_top": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_top"
    ]
  },
  "083c6f6a-5f37-419d-947f-5f1aa0daae01": {
    "has_axis": [
      "083c6f6a-5f37-419d-947f-5f1aa0daae01_bottom",
      "083c6f6a-5f37-419d-947f-5f1aa0daae01_left",
      "083c6f6a-5f37-419d-947f-5f1aa0daae01_right",
      "083c6f6a-5f37-419d-947f-5f1aa0daae01_top",
      "083c6f6a-5f37-419d-947f-5f1aa0daae01_top_offset_-32"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "083c6f6a-5f37-419d-947f-5f1aa0daae01_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "083c6f6a-5f37-419d-947f-5f1aa0daae01_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "083c6f6a-5f37-419d-947f-5f1aa0daae01_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "083c6f6a-5f37-419d-947f-5f1aa0daae01_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "0892589a-e09d-4d9b-bb9e-f48a76b0553d": {
    "has_axis": [
      "0892589a-e09d-4d9b-bb9e-f48a76b0553d_bottom",
      "0892589a-e09d-4d9b-bb9e-f48a76b0553d_left",
      "0892589a-e09d-4d9b-bb9e-f48a76b0553d_right",
      "0892589a-e09d-4d9b-bb9e-f48a76b0553d_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "0892589a-e09d-4d9b-bb9e-f48a76b0553d_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "0892589a-e09d-4d9b-bb9e-f48a76b0553d_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "0892589a-e09d-4d9b-bb9e-f48a76b0553d_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "0892589a-e09d-4d9b-bb9e-f48a76b0553d_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "08dc04fb-9b47-4756-a556-d64d3d807823": {
    "has_axis": [
      "08dc04fb-9b47-4756-a556-d64d3d807823_bottom",
      "08dc04fb-9b47-4756-a556-d64d3d807823_left",
      "08dc04fb-9b47-4756-a556-d64d3d807823_right",
      "08dc04fb-9b47-4756-a556-d64d3d807823_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "08dc04fb-9b47-4756-a556-d64d3d807823_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "08dc04fb-9b47-4756-a556-d64d3d807823_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "08dc04fb-9b47-4756-a556-d64d3d807823_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "08dc04fb-9b47-4756-a556-d64d3d807823_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "0a74fb54-1b31-46d6-a8b8-e13c292e8069": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "0a74fb54-1b31-46d6-a8b8-e13c292e8069_bottom",
      "0a74fb54-1b31-46d6-a8b8-e13c292e8069_left",
      "0a74fb54-1b31-46d6-a8b8-e13c292e8069_right",
      "0a74fb54-1b31-46d6-a8b8-e13c292e8069_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "0a74fb54-1b31-46d6-a8b8-e13c292e8069_bottom": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom"
    ]
  },
  "0a74fb54-1b31-46d6-a8b8-e13c292e8069_left": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "0a74fb54-1b31-46d6-a8b8-e13c292e8069_right": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "0a74fb54-1b31-46d6-a8b8-e13c292e8069_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "0e3cc635-21ea-42f2-b03c-81d94dea1202": {
    "has_axis": [
      "0e3cc635-21ea-42f2-b03c-81d94dea1202_bottom",
      "0e3cc635-21ea-42f2-b03c-81d94dea1202_left",
      "0e3cc635-21ea-42f2-b03c-81d94dea1202_right",
      "0e3cc635-21ea-42f2-b03c-81d94dea1202_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "0e3cc635-21ea-42f2-b03c-81d94dea1202_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "0e3cc635-21ea-42f2-b03c-81d94dea1202_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "0e3cc635-21ea-42f2-b03c-81d94dea1202_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "0e3cc635-21ea-42f2-b03c-81d94dea1202_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "0e4730ae-e29b-4e31-9cde-682868356ae9": {
    "has_axis": [
      "0e4730ae-e29b-4e31-9cde-682868356ae9_bottom",
      "0e4730ae-e29b-4e31-9cde-682868356ae9_left",
      "0e4730ae-e29b-4e31-9cde-682868356ae9_right",
      "0e4730ae-e29b-4e31-9cde-682868356ae9_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "0e4730ae-e29b-4e31-9cde-682868356ae9_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "0e4730ae-e29b-4e31-9cde-682868356ae9_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "0e4730ae-e29b-4e31-9cde-682868356ae9_right": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "0e4730ae-e29b-4e31-9cde-682868356ae9_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "0e5c3389-b4ca-4ffe-9347-a5d1280df7db": {
    "has_axis": [
      "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_bottom",
      "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_left",
      "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_right",
      "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_top"
    ],
    "has_role": [
      "custom:icon"
    ],
    "is_a": [
      "image"
    ]
  },
  "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "0e5c3389-b4ca-4ffe-9347-a5d1280df7db_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "10110498-84dd-4eac-a05f-1d6a6786cc39": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "10110498-84dd-4eac-a05f-1d6a6786cc39_bottom",
      "10110498-84dd-4eac-a05f-1d6a6786cc39_left",
      "10110498-84dd-4eac-a05f-1d6a6786cc39_right",
      "10110498-84dd-4eac-a05f-1d6a6786cc39_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "10110498-84dd-4eac-a05f-1d6a6786cc39_bottom": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom"
    ]
  },
  "10110498-84dd-4eac-a05f-1d6a6786cc39_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "10110498-84dd-4eac-a05f-1d6a6786cc39_right": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_right"
    ]
  },
  "10110498-84dd-4eac-a05f-1d6a6786cc39_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "105a38cf-643c-4c9e-9eb7-9a266559c7b5": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "1358493b-5dcd-4cce-8fa0-ff202683852d": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "1358493b-5dcd-4cce-8fa0-ff202683852d_bottom",
      "1358493b-5dcd-4cce-8fa0-ff202683852d_left",
      "1358493b-5dcd-4cce-8fa0-ff202683852d_right",
      "1358493b-5dcd-4cce-8fa0-ff202683852d_top"
    ],
    "has_role": [
      "subtitle"
    ],
    "is_a": [
      "text"
    ]
  },
  "1358493b-5dcd-4cce-8fa0-ff202683852d_bottom": {
    "is_limited_by": [
      "9319ba0d-afcf-4507-84ad-0028651706d4_bottom_offset_-32"
    ]
  },
  "1358493b-5dcd-4cce-8fa0-ff202683852d_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "1358493b-5dcd-4cce-8fa0-ff202683852d_right": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_right"
    ]
  },
  "1358493b-5dcd-4cce-8fa0-ff202683852d_top": {
    "is_pinned_to": [
      "c403034c-0a73-49a8-9539-7e5352f740c5_bottom"
    ]
  },
  "14ee8467-275d-47eb-8252-74dde64e8179": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "14ee8467-275d-47eb-8252-74dde64e8179_bottom",
      "14ee8467-275d-47eb-8252-74dde64e8179_left",
      "14ee8467-275d-47eb-8252-74dde64e8179_right",
      "14ee8467-275d-47eb-8252-74dde64e8179_top"
    ],
    "has_role": [
      "subtitle"
    ],
    "is_a": [
      "text"
    ]
  },
  "14ee8467-275d-47eb-8252-74dde64e8179_bottom": {
    "is_limited_by": [
      "999ff148-dd0a-4654-96fb-ec416264c291_bottom_offset_-32"
    ]
  },
  "14ee8467-275d-47eb-8252-74dde64e8179_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "14ee8467-275d-47eb-8252-74dde64e8179_right": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_right"
    ]
  },
  "14ee8467-275d-47eb-8252-74dde64e8179_top": {
    "is_pinned_to": [
      "29c6b33a-e04d-444b-a462-d25e577832ff_bottom"
    ]
  },
  "152bfeb9-aa0c-42cf-b639-d3f63556df80": {
    "has_axis": [
      "152bfeb9-aa0c-42cf-b639-d3f63556df80_bottom",
      "152bfeb9-aa0c-42cf-b639-d3f63556df80_left",
      "152bfeb9-aa0c-42cf-b639-d3f63556df80_right",
      "152bfeb9-aa0c-42cf-b639-d3f63556df80_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "152bfeb9-aa0c-42cf-b639-d3f63556df80_bottom": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "152bfeb9-aa0c-42cf-b639-d3f63556df80_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "152bfeb9-aa0c-42cf-b639-d3f63556df80_right": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "152bfeb9-aa0c-42cf-b639-d3f63556df80_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "16f01b56-5e50-4aba-8a4d-04202d4aa796": {
    "has_attribute": [
      "text_auto_width"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "18099207-fd29-41eb-b50c-266787682802": {
    "has_axis": [
      "18099207-fd29-41eb-b50c-266787682802_bottom",
      "18099207-fd29-41eb-b50c-266787682802_left",
      "18099207-fd29-41eb-b50c-266787682802_right",
      "18099207-fd29-41eb-b50c-266787682802_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "18099207-fd29-41eb-b50c-266787682802_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "18099207-fd29-41eb-b50c-266787682802_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "18099207-fd29-41eb-b50c-266787682802_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "18099207-fd29-41eb-b50c-266787682802_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "1b8e67c5-8972-4f37-bc8e-2431e93e627d": {
    "has_role": [
      "content"
    ],
    "is_a": [
      "image"
    ]
  },
  "1dc8a7d1-059f-4740-8ad8-5268f85ed647": {
    "has_axis": [
      "1dc8a7d1-059f-4740-8ad8-5268f85ed647_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "1f501127-fe01-4a44-afa6-4b53f5a40be4": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "1f501127-fe01-4a44-afa6-4b53f5a40be4_bottom",
      "1f501127-fe01-4a44-afa6-4b53f5a40be4_left",
      "1f501127-fe01-4a44-afa6-4b53f5a40be4_right",
      "1f501127-fe01-4a44-afa6-4b53f5a40be4_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "1f501127-fe01-4a44-afa6-4b53f5a40be4_bottom": {
    "is_limited_by": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom"
    ]
  },
  "1f501127-fe01-4a44-afa6-4b53f5a40be4_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "1f501127-fe01-4a44-afa6-4b53f5a40be4_right": {
    "is_limited_by": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_right"
    ]
  },
  "1f501127-fe01-4a44-afa6-4b53f5a40be4_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "2342c752-7b06-4b38-84a8-6adc01291aed": {
    "has_axis": [
      "2342c752-7b06-4b38-84a8-6adc01291aed_bottom",
      "2342c752-7b06-4b38-84a8-6adc01291aed_left",
      "2342c752-7b06-4b38-84a8-6adc01291aed_left_offset_-32",
      "2342c752-7b06-4b38-84a8-6adc01291aed_right",
      "2342c752-7b06-4b38-84a8-6adc01291aed_top",
      "2342c752-7b06-4b38-84a8-6adc01291aed_top_offset_-32"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "2342c752-7b06-4b38-84a8-6adc01291aed_bottom": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "2342c752-7b06-4b38-84a8-6adc01291aed_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "2342c752-7b06-4b38-84a8-6adc01291aed_right": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "2342c752-7b06-4b38-84a8-6adc01291aed_top": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "26c813bc-f7c7-46e4-9ad2-e002d07208d4": {
    "has_axis": [
      "26c813bc-f7c7-46e4-9ad2-e002d07208d4_left",
      "26c813bc-f7c7-46e4-9ad2-e002d07208d4_left_offset_-32"
    ],
    "has_role": [
      "custom:personaAvatar"
    ],
    "is_a": [
      "image"
    ]
  },
  "29242deb-3150-4dad-b090-d928893bfd04": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "29242deb-3150-4dad-b090-d928893bfd04_bottom",
      "29242deb-3150-4dad-b090-d928893bfd04_left",
      "29242deb-3150-4dad-b090-d928893bfd04_right",
      "29242deb-3150-4dad-b090-d928893bfd04_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "29242deb-3150-4dad-b090-d928893bfd04_bottom": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom"
    ]
  },
  "29242deb-3150-4dad-b090-d928893bfd04_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "29242deb-3150-4dad-b090-d928893bfd04_right": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_right"
    ]
  },
  "29242deb-3150-4dad-b090-d928893bfd04_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "2931e5d2-ce81-42e9-a4ad-66ddf0f449e6": {
    "is_a": [
      "image"
    ]
  },
  "29c6b33a-e04d-444b-a462-d25e577832ff": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "29c6b33a-e04d-444b-a462-d25e577832ff_bottom",
      "29c6b33a-e04d-444b-a462-d25e577832ff_left",
      "29c6b33a-e04d-444b-a462-d25e577832ff_right",
      "29c6b33a-e04d-444b-a462-d25e577832ff_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "29c6b33a-e04d-444b-a462-d25e577832ff_bottom": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom"
    ]
  },
  "29c6b33a-e04d-444b-a462-d25e577832ff_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "29c6b33a-e04d-444b-a462-d25e577832ff_right": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_right"
    ]
  },
  "29c6b33a-e04d-444b-a462-d25e577832ff_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "2c989e52-7716-43e9-85d9-d08dcd08cb43": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "2c989e52-7716-43e9-85d9-d08dcd08cb43_bottom",
      "2c989e52-7716-43e9-85d9-d08dcd08cb43_left",
      "2c989e52-7716-43e9-85d9-d08dcd08cb43_right",
      "2c989e52-7716-43e9-85d9-d08dcd08cb43_top"
    ],
    "has_role": [
      "custom:chapter"
    ],
    "is_a": [
      "text"
    ]
  },
  "2c989e52-7716-43e9-85d9-d08dcd08cb43_bottom": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom"
    ]
  },
  "2c989e52-7716-43e9-85d9-d08dcd08cb43_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "2c989e52-7716-43e9-85d9-d08dcd08cb43_right": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_right"
    ]
  },
  "2c989e52-7716-43e9-85d9-d08dcd08cb43_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "315f7ad5-00c2-4fbb-8239-836b86a53ecc": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "315f7ad5-00c2-4fbb-8239-836b86a53ecc_bottom",
      "315f7ad5-00c2-4fbb-8239-836b86a53ecc_left",
      "315f7ad5-00c2-4fbb-8239-836b86a53ecc_right",
      "315f7ad5-00c2-4fbb-8239-836b86a53ecc_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "315f7ad5-00c2-4fbb-8239-836b86a53ecc_bottom": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom"
    ]
  },
  "315f7ad5-00c2-4fbb-8239-836b86a53ecc_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "315f7ad5-00c2-4fbb-8239-836b86a53ecc_right": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_right"
    ]
  },
  "315f7ad5-00c2-4fbb-8239-836b86a53ecc_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "32fd34ec-3db9-4c63-98c8-f6edeb97505b": {
    "contains": [
      "9b0f28ba-748a-4112-84e4-65335022c8de"
    ],
    "has_axis": [
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b_left",
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b_top"
    ],
    "has_role": [
      "small_title"
    ],
    "is_a": [
      "slide"
    ]
  },
  "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa": {
    "has_axis": [
      "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_bottom",
      "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_left",
      "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_right",
      "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_bottom": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_right": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa_top": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "3373f59d-272e-4d2d-b6b4-b86b27f6d449": {
    "has_axis": [
      "3373f59d-272e-4d2d-b6b4-b86b27f6d449_bottom",
      "3373f59d-272e-4d2d-b6b4-b86b27f6d449_left",
      "3373f59d-272e-4d2d-b6b4-b86b27f6d449_right",
      "3373f59d-272e-4d2d-b6b4-b86b27f6d449_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "3373f59d-272e-4d2d-b6b4-b86b27f6d449_bottom": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "3373f59d-272e-4d2d-b6b4-b86b27f6d449_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "3373f59d-272e-4d2d-b6b4-b86b27f6d449_right": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "3373f59d-272e-4d2d-b6b4-b86b27f6d449_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "33c28ef4-17fa-401b-ade1-a998647c587c": {
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "3a6eb667-0bd1-462a-a3ff-63fadc096926": {
    "has_axis": [
      "3a6eb667-0bd1-462a-a3ff-63fadc096926_bottom",
      "3a6eb667-0bd1-462a-a3ff-63fadc096926_left",
      "3a6eb667-0bd1-462a-a3ff-63fadc096926_right",
      "3a6eb667-0bd1-462a-a3ff-63fadc096926_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "3a6eb667-0bd1-462a-a3ff-63fadc096926_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "3a6eb667-0bd1-462a-a3ff-63fadc096926_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "3a6eb667-0bd1-462a-a3ff-63fadc096926_right": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "3a6eb667-0bd1-462a-a3ff-63fadc096926_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "3c566718-4899-439f-bac4-3c58a81f1aa7": {
    "contains": [
      "1358493b-5dcd-4cce-8fa0-ff202683852d",
      "3373f59d-272e-4d2d-b6b4-b86b27f6d449",
      "3e4fbb51-a64a-41dd-b901-73178209d106",
      "5d8ee7c5-a782-45fc-bd27-6deb01c3adac",
      "655813bf-5c37-4f16-a058-11e76e0ce701",
      "66253b03-f652-4093-bef9-8cdf7eb130fd",
      "9319ba0d-afcf-4507-84ad-0028651706d4",
      "c403034c-0a73-49a8-9539-7e5352f740c5"
    ],
    "has_axis": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_bottom",
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left",
      "3c566718-4899-439f-bac4-3c58a81f1aa7_right",
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ],
    "has_role": [
      "small_title"
    ],
    "is_a": [
      "slide"
    ]
  },
  "3c81a404-ffbb-40ff-8a55-2d1a6a7de35d": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_role": [
      "custom:personaRole"
    ],
    "is_a": [
      "text"
    ]
  },
  "3dcae55c-5ebc-4a46-a381-a98ef638bfb4": {
    "has_axis": [
      "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_bottom",
      "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_left",
      "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_right",
      "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_bottom": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_right": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "3dcae55c-5ebc-4a46-a381-a98ef638bfb4_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "3e4fbb51-a64a-41dd-b901-73178209d106": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "3e4fbb51-a64a-41dd-b901-73178209d106_bottom",
      "3e4fbb51-a64a-41dd-b901-73178209d106_left",
      "3e4fbb51-a64a-41dd-b901-73178209d106_right",
      "3e4fbb51-a64a-41dd-b901-73178209d106_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "3e4fbb51-a64a-41dd-b901-73178209d106_bottom": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_bottom"
    ]
  },
  "3e4fbb51-a64a-41dd-b901-73178209d106_left": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "3e4fbb51-a64a-41dd-b901-73178209d106_right": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "3e4fbb51-a64a-41dd-b901-73178209d106_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "3eeacefe-1c84-4637-b4a5-d988c4411b34": {
    "has_axis": [
      "3eeacefe-1c84-4637-b4a5-d988c4411b34_bottom",
      "3eeacefe-1c84-4637-b4a5-d988c4411b34_left",
      "3eeacefe-1c84-4637-b4a5-d988c4411b34_right",
      "3eeacefe-1c84-4637-b4a5-d988c4411b34_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "3eeacefe-1c84-4637-b4a5-d988c4411b34_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "3eeacefe-1c84-4637-b4a5-d988c4411b34_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "3eeacefe-1c84-4637-b4a5-d988c4411b34_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "3eeacefe-1c84-4637-b4a5-d988c4411b34_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "40802aad-299d-45e9-8c97-099453c995f8": {
    "has_axis": [
      "40802aad-299d-45e9-8c97-099453c995f8_bottom",
      "40802aad-299d-45e9-8c97-099453c995f8_left",
      "40802aad-299d-45e9-8c97-099453c995f8_right",
      "40802aad-299d-45e9-8c97-099453c995f8_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "40802aad-299d-45e9-8c97-099453c995f8_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "40802aad-299d-45e9-8c97-099453c995f8_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "40802aad-299d-45e9-8c97-099453c995f8_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "40802aad-299d-45e9-8c97-099453c995f8_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "419fda32-2472-49ec-80a7-8bdd6b504d70": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "419fda32-2472-49ec-80a7-8bdd6b504d70_bottom",
      "419fda32-2472-49ec-80a7-8bdd6b504d70_left",
      "419fda32-2472-49ec-80a7-8bdd6b504d70_right",
      "419fda32-2472-49ec-80a7-8bdd6b504d70_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "419fda32-2472-49ec-80a7-8bdd6b504d70_bottom": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_bottom"
    ]
  },
  "419fda32-2472-49ec-80a7-8bdd6b504d70_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "419fda32-2472-49ec-80a7-8bdd6b504d70_right": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_right"
    ]
  },
  "419fda32-2472-49ec-80a7-8bdd6b504d70_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "41ab1c7e-f28c-4e16-9962-c5cad2635096": {
    "has_axis": [
      "41ab1c7e-f28c-4e16-9962-c5cad2635096_bottom",
      "41ab1c7e-f28c-4e16-9962-c5cad2635096_left",
      "41ab1c7e-f28c-4e16-9962-c5cad2635096_right",
      "41ab1c7e-f28c-4e16-9962-c5cad2635096_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "41ab1c7e-f28c-4e16-9962-c5cad2635096_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "41ab1c7e-f28c-4e16-9962-c5cad2635096_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "41ab1c7e-f28c-4e16-9962-c5cad2635096_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "41ab1c7e-f28c-4e16-9962-c5cad2635096_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0": {
    "has_axis": [
      "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_bottom",
      "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_left",
      "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_right",
      "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "4574aea6-3b0d-4e30-aa06-fdcb420a34d0": {
    "has_axis": [
      "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_bottom",
      "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_left",
      "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_right",
      "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_top"
    ],
    "has_role": [
      "custom:visual"
    ],
    "is_a": [
      "image"
    ]
  },
  "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_bottom": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_right": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "4574aea6-3b0d-4e30-aa06-fdcb420a34d0_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "47560dac-0bcf-45bc-8470-d46d2faa5df7": {
    "has_axis": [
      "47560dac-0bcf-45bc-8470-d46d2faa5df7_bottom",
      "47560dac-0bcf-45bc-8470-d46d2faa5df7_left",
      "47560dac-0bcf-45bc-8470-d46d2faa5df7_right",
      "47560dac-0bcf-45bc-8470-d46d2faa5df7_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "47560dac-0bcf-45bc-8470-d46d2faa5df7_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "47560dac-0bcf-45bc-8470-d46d2faa5df7_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "47560dac-0bcf-45bc-8470-d46d2faa5df7_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "47560dac-0bcf-45bc-8470-d46d2faa5df7_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "48f59b8a-ad78-4fbc-add6-9cb6a922c231": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "4b7caf30-116b-4384-9028-d352fefc571d": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "4f18efff-7c4e-4636-8d01-032d5e4c7a73": {
    "has_axis": [
      "4f18efff-7c4e-4636-8d01-032d5e4c7a73_bottom",
      "4f18efff-7c4e-4636-8d01-032d5e4c7a73_left",
      "4f18efff-7c4e-4636-8d01-032d5e4c7a73_right",
      "4f18efff-7c4e-4636-8d01-032d5e4c7a73_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "4f18efff-7c4e-4636-8d01-032d5e4c7a73_bottom": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "4f18efff-7c4e-4636-8d01-032d5e4c7a73_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "4f18efff-7c4e-4636-8d01-032d5e4c7a73_right": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "4f18efff-7c4e-4636-8d01-032d5e4c7a73_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "506097e9-1862-4658-95e7-a9ce78273fca": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "510134a1-8d81-4e98-8d68-0f5290eea590": {
    "is_a": [
      "image"
    ]
  },
  "53a5017d-0be5-4de5-a423-60e89dd51e14": {
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "56239588-5483-4761-87b9-ded11fcdaa64": {
    "has_axis": [
      "56239588-5483-4761-87b9-ded11fcdaa64_bottom",
      "56239588-5483-4761-87b9-ded11fcdaa64_left",
      "56239588-5483-4761-87b9-ded11fcdaa64_right",
      "56239588-5483-4761-87b9-ded11fcdaa64_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "56239588-5483-4761-87b9-ded11fcdaa64_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "56239588-5483-4761-87b9-ded11fcdaa64_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "56239588-5483-4761-87b9-ded11fcdaa64_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "56239588-5483-4761-87b9-ded11fcdaa64_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "58d1cbba-5637-48a1-b003-c6c585a07cfe": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "58d1cbba-5637-48a1-b003-c6c585a07cfe_bottom",
      "58d1cbba-5637-48a1-b003-c6c585a07cfe_left",
      "58d1cbba-5637-48a1-b003-c6c585a07cfe_right",
      "58d1cbba-5637-48a1-b003-c6c585a07cfe_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "58d1cbba-5637-48a1-b003-c6c585a07cfe_bottom": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom"
    ]
  },
  "58d1cbba-5637-48a1-b003-c6c585a07cfe_left": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "58d1cbba-5637-48a1-b003-c6c585a07cfe_right": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "58d1cbba-5637-48a1-b003-c6c585a07cfe_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "5c1877e5-848b-427d-8bea-ebb92fd92b6a": {
    "has_axis": [
      "5c1877e5-848b-427d-8bea-ebb92fd92b6a_bottom",
      "5c1877e5-848b-427d-8bea-ebb92fd92b6a_left",
      "5c1877e5-848b-427d-8bea-ebb92fd92b6a_right",
      "5c1877e5-848b-427d-8bea-ebb92fd92b6a_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "5c1877e5-848b-427d-8bea-ebb92fd92b6a_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "5c1877e5-848b-427d-8bea-ebb92fd92b6a_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "5c1877e5-848b-427d-8bea-ebb92fd92b6a_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "5c1877e5-848b-427d-8bea-ebb92fd92b6a_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "5d8ee7c5-a782-45fc-bd27-6deb01c3adac": {
    "has_axis": [
      "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_bottom",
      "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_left",
      "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_right",
      "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_bottom": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_right": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "5d8ee7c5-a782-45fc-bd27-6deb01c3adac_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_bottom",
      "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_left",
      "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_right",
      "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_bottom": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom"
    ]
  },
  "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_left": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "5f52d182-db39-48d5-9ea0-24d231fad72b": {
    "has_axis": [
      "5f52d182-db39-48d5-9ea0-24d231fad72b_bottom",
      "5f52d182-db39-48d5-9ea0-24d231fad72b_left",
      "5f52d182-db39-48d5-9ea0-24d231fad72b_right",
      "5f52d182-db39-48d5-9ea0-24d231fad72b_top"
    ],
    "has_role": [
      "custom:visual"
    ],
    "is_a": [
      "image"
    ]
  },
  "5f52d182-db39-48d5-9ea0-24d231fad72b_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "5f52d182-db39-48d5-9ea0-24d231fad72b_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "5f52d182-db39-48d5-9ea0-24d231fad72b_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "5f52d182-db39-48d5-9ea0-24d231fad72b_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "5feed6ff-1382-46bc-ae1f-713609ac0045": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "5feed6ff-1382-46bc-ae1f-713609ac0045_bottom",
      "5feed6ff-1382-46bc-ae1f-713609ac0045_left",
      "5feed6ff-1382-46bc-ae1f-713609ac0045_right",
      "5feed6ff-1382-46bc-ae1f-713609ac0045_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "5feed6ff-1382-46bc-ae1f-713609ac0045_bottom": {
    "is_limited_by": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_bottom"
    ]
  },
  "5feed6ff-1382-46bc-ae1f-713609ac0045_left": {
    "is_limited_by": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "5feed6ff-1382-46bc-ae1f-713609ac0045_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "5feed6ff-1382-46bc-ae1f-713609ac0045_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "60389d63-842f-48e8-9536-ce2404aaf2bf": {
    "has_axis": [
      "60389d63-842f-48e8-9536-ce2404aaf2bf_bottom",
      "60389d63-842f-48e8-9536-ce2404aaf2bf_left",
      "60389d63-842f-48e8-9536-ce2404aaf2bf_left_offset_-32",
      "60389d63-842f-48e8-9536-ce2404aaf2bf_right",
      "60389d63-842f-48e8-9536-ce2404aaf2bf_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "image"
    ]
  },
  "60389d63-842f-48e8-9536-ce2404aaf2bf_bottom": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_bottom"
    ]
  },
  "60389d63-842f-48e8-9536-ce2404aaf2bf_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "60389d63-842f-48e8-9536-ce2404aaf2bf_right": {
    "is_limited_by": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_right"
    ]
  },
  "60389d63-842f-48e8-9536-ce2404aaf2bf_top": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "62b07357-43e1-4fbc-968c-6f6b6eead503": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "62b07357-43e1-4fbc-968c-6f6b6eead503_bottom",
      "62b07357-43e1-4fbc-968c-6f6b6eead503_left",
      "62b07357-43e1-4fbc-968c-6f6b6eead503_right",
      "62b07357-43e1-4fbc-968c-6f6b6eead503_top"
    ],
    "has_role": [
      "subtitle"
    ],
    "is_a": [
      "text"
    ]
  },
  "62b07357-43e1-4fbc-968c-6f6b6eead503_bottom": {
    "is_limited_by": [
      "cbf21645-b078-4812-b755-d8ecae9ef204_top"
    ]
  },
  "62b07357-43e1-4fbc-968c-6f6b6eead503_left": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_left"
    ]
  },
  "62b07357-43e1-4fbc-968c-6f6b6eead503_right": {
    "is_limited_by": [
      "731d57c9-7588-4ca3-a019-5618a436794a_right"
    ]
  },
  "62b07357-43e1-4fbc-968c-6f6b6eead503_top": {
    "is_pinned_to": [
      "062e6859-d511-484c-bac3-388fccb01635_bottom"
    ]
  },
  "640f3598-52e6-4d5d-929e-1357754b5b2a": {
    "has_attribute": [
      "text_auto_width"
    ],
    "has_axis": [
      "640f3598-52e6-4d5d-929e-1357754b5b2a_bottom",
      "640f3598-52e6-4d5d-929e-1357754b5b2a_left",
      "640f3598-52e6-4d5d-929e-1357754b5b2a_right",
      "640f3598-52e6-4d5d-929e-1357754b5b2a_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "640f3598-52e6-4d5d-929e-1357754b5b2a_bottom": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_bottom"
    ]
  },
  "640f3598-52e6-4d5d-929e-1357754b5b2a_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "640f3598-52e6-4d5d-929e-1357754b5b2a_right": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_right"
    ]
  },
  "640f3598-52e6-4d5d-929e-1357754b5b2a_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "6413dc3d-e450-4649-9bc9-5b590d6ddd06": {
    "has_axis": [
      "6413dc3d-e450-4649-9bc9-5b590d6ddd06_bottom",
      "6413dc3d-e450-4649-9bc9-5b590d6ddd06_left",
      "6413dc3d-e450-4649-9bc9-5b590d6ddd06_right",
      "6413dc3d-e450-4649-9bc9-5b590d6ddd06_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "6413dc3d-e450-4649-9bc9-5b590d6ddd06_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "6413dc3d-e450-4649-9bc9-5b590d6ddd06_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "6413dc3d-e450-4649-9bc9-5b590d6ddd06_right": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "6413dc3d-e450-4649-9bc9-5b590d6ddd06_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "64358dd5-ae6a-4b59-9d2d-1b051def1d82": {
    "contains": [
      "083c6f6a-5f37-419d-947f-5f1aa0daae01",
      "08dc04fb-9b47-4756-a556-d64d3d807823",
      "29242deb-3150-4dad-b090-d928893bfd04",
      "315f7ad5-00c2-4fbb-8239-836b86a53ecc",
      "41ab1c7e-f28c-4e16-9962-c5cad2635096",
      "47560dac-0bcf-45bc-8470-d46d2faa5df7",
      "56239588-5483-4761-87b9-ded11fcdaa64",
      "5c1877e5-848b-427d-8bea-ebb92fd92b6a",
      "5e3c15a9-7c6a-4eec-b894-d095d1e9dd11",
      "6a235815-2168-4ec8-8fba-3110962fdd16",
      "79ec29c4-a287-49aa-8ac4-eae4d134da1d",
      "ba4fd689-f519-411d-9f85-e7f440e22ec4",
      "e75d149c-7ddd-4f4e-a151-14a59ea98ffb",
      "ec9156be-f2e5-46c9-97b5-fe769bda3ed9",
      "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321"
    ],
    "has_axis": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom",
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left",
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_right",
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "slide"
    ]
  },
  "655813bf-5c37-4f16-a058-11e76e0ce701": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "655813bf-5c37-4f16-a058-11e76e0ce701_bottom",
      "655813bf-5c37-4f16-a058-11e76e0ce701_left",
      "655813bf-5c37-4f16-a058-11e76e0ce701_right",
      "655813bf-5c37-4f16-a058-11e76e0ce701_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "655813bf-5c37-4f16-a058-11e76e0ce701_bottom": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_bottom"
    ]
  },
  "655813bf-5c37-4f16-a058-11e76e0ce701_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "655813bf-5c37-4f16-a058-11e76e0ce701_right": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_right"
    ]
  },
  "655813bf-5c37-4f16-a058-11e76e0ce701_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "65712f61-cfc5-4c4e-9563-b6ab2eab5902": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "65712f61-cfc5-4c4e-9563-b6ab2eab5902_bottom",
      "65712f61-cfc5-4c4e-9563-b6ab2eab5902_left",
      "65712f61-cfc5-4c4e-9563-b6ab2eab5902_right",
      "65712f61-cfc5-4c4e-9563-b6ab2eab5902_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "65712f61-cfc5-4c4e-9563-b6ab2eab5902_bottom": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom"
    ]
  },
  "65712f61-cfc5-4c4e-9563-b6ab2eab5902_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "65712f61-cfc5-4c4e-9563-b6ab2eab5902_right": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_right"
    ]
  },
  "65712f61-cfc5-4c4e-9563-b6ab2eab5902_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "66253b03-f652-4093-bef9-8cdf7eb130fd": {
    "has_axis": [
      "66253b03-f652-4093-bef9-8cdf7eb130fd_bottom",
      "66253b03-f652-4093-bef9-8cdf7eb130fd_left",
      "66253b03-f652-4093-bef9-8cdf7eb130fd_right",
      "66253b03-f652-4093-bef9-8cdf7eb130fd_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "66253b03-f652-4093-bef9-8cdf7eb130fd_bottom": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "66253b03-f652-4093-bef9-8cdf7eb130fd_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "66253b03-f652-4093-bef9-8cdf7eb130fd_right": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "66253b03-f652-4093-bef9-8cdf7eb130fd_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "676d177d-0f68-4da3-9fff-575c0ca96cef": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "676d177d-0f68-4da3-9fff-575c0ca96cef_bottom",
      "676d177d-0f68-4da3-9fff-575c0ca96cef_left",
      "676d177d-0f68-4da3-9fff-575c0ca96cef_right",
      "676d177d-0f68-4da3-9fff-575c0ca96cef_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "text"
    ]
  },
  "676d177d-0f68-4da3-9fff-575c0ca96cef_bottom": {
    "is_limited_by": [
      "9efd4120-5fef-4551-a1d0-cc41a3f0a930_top"
    ]
  },
  "676d177d-0f68-4da3-9fff-575c0ca96cef_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "676d177d-0f68-4da3-9fff-575c0ca96cef_right": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_right"
    ]
  },
  "676d177d-0f68-4da3-9fff-575c0ca96cef_top": {
    "is_pinned_to": [
      "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_bottom"
    ]
  },
  "6929c343-70aa-4324-b590-5bfafd176df0": {
    "has_axis": [
      "6929c343-70aa-4324-b590-5bfafd176df0_bottom",
      "6929c343-70aa-4324-b590-5bfafd176df0_left",
      "6929c343-70aa-4324-b590-5bfafd176df0_right",
      "6929c343-70aa-4324-b590-5bfafd176df0_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "6929c343-70aa-4324-b590-5bfafd176df0_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "6929c343-70aa-4324-b590-5bfafd176df0_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "6929c343-70aa-4324-b590-5bfafd176df0_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "6929c343-70aa-4324-b590-5bfafd176df0_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "69b7a4e4-a179-46e0-8576-8a861a67e156": {
    "has_axis": [
      "69b7a4e4-a179-46e0-8576-8a861a67e156_bottom",
      "69b7a4e4-a179-46e0-8576-8a861a67e156_left",
      "69b7a4e4-a179-46e0-8576-8a861a67e156_right",
      "69b7a4e4-a179-46e0-8576-8a861a67e156_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "69b7a4e4-a179-46e0-8576-8a861a67e156_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "69b7a4e4-a179-46e0-8576-8a861a67e156_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "69b7a4e4-a179-46e0-8576-8a861a67e156_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "69b7a4e4-a179-46e0-8576-8a861a67e156_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "6a235815-2168-4ec8-8fba-3110962fdd16": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "6a235815-2168-4ec8-8fba-3110962fdd16_bottom",
      "6a235815-2168-4ec8-8fba-3110962fdd16_left",
      "6a235815-2168-4ec8-8fba-3110962fdd16_right",
      "6a235815-2168-4ec8-8fba-3110962fdd16_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "6a235815-2168-4ec8-8fba-3110962fdd16_bottom": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom"
    ]
  },
  "6a235815-2168-4ec8-8fba-3110962fdd16_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "6a235815-2168-4ec8-8fba-3110962fdd16_right": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_right"
    ]
  },
  "6a235815-2168-4ec8-8fba-3110962fdd16_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "6a2513b9-c09b-484e-896f-398b1a5e8a36": {
    "is_a": [
      "image"
    ]
  },
  "6d4b04b8-5837-45fa-a49f-0d6a15e4348e": {
    "contains": [
      "2342c752-7b06-4b38-84a8-6adc01291aed",
      "331aa7bd-4787-4ca1-9e7d-3e6eff3100fa",
      "33c28ef4-17fa-401b-ade1-a998647c587c",
      "53a5017d-0be5-4de5-a423-60e89dd51e14",
      "60389d63-842f-48e8-9536-ce2404aaf2bf",
      "8c253f46-2c3c-4db4-8860-8a02f9ccfde7",
      "98743a8c-2f78-488b-b954-f09081e57d2a",
      "a2d3b917-7f07-46f1-991c-97273ee3275c",
      "ab0eb597-2dcd-4869-b761-f22f2e514dd4",
      "ccf00a0f-8a27-4c3b-8119-b2f8b7723469",
      "fccda08f-b71b-4661-bdbd-157f12aca817"
    ],
    "has_axis": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_bottom",
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left",
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_right",
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "slide"
    ]
  },
  "6d8d7dd5-b88c-4f34-ab46-b28fc765d86d": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "6ddf3890-7cba-4470-bb02-2321ac7f7a77": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "6ddf3890-7cba-4470-bb02-2321ac7f7a77_bottom",
      "6ddf3890-7cba-4470-bb02-2321ac7f7a77_left",
      "6ddf3890-7cba-4470-bb02-2321ac7f7a77_right",
      "6ddf3890-7cba-4470-bb02-2321ac7f7a77_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "6ddf3890-7cba-4470-bb02-2321ac7f7a77_bottom": {
    "is_limited_by": [
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_top_offset_-32"
    ]
  },
  "6ddf3890-7cba-4470-bb02-2321ac7f7a77_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "6ddf3890-7cba-4470-bb02-2321ac7f7a77_right": {
    "is_limited_by": [
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89_left_offset_-32"
    ]
  },
  "6ddf3890-7cba-4470-bb02-2321ac7f7a77_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "716445cb-1a99-4546-a262-990ce93f5b14": {
    "is_a": [
      "image"
    ]
  },
  "731d57c9-7588-4ca3-a019-5618a436794a": {
    "contains": [
      "062e6859-d511-484c-bac3-388fccb01635",
      "62b07357-43e1-4fbc-968c-6f6b6eead503",
      "8c715784-9caa-4cac-9273-9260ed88a96f",
      "cbf21645-b078-4812-b755-d8ecae9ef204"
    ],
    "has_axis": [
      "731d57c9-7588-4ca3-a019-5618a436794a_bottom",
      "731d57c9-7588-4ca3-a019-5618a436794a_left",
      "731d57c9-7588-4ca3-a019-5618a436794a_right",
      "731d57c9-7588-4ca3-a019-5618a436794a_top"
    ],
    "has_role": [
      "cover"
    ],
    "has_theme": [
      "e216c9a2-fb09-4e7e-9e84-c2b37c715cdf"
    ],
    "is_a": [
      "slide"
    ]
  },
  "7525a5d2-c947-401d-a8e1-48c943f17cfc": {
    "has_axis": [
      "7525a5d2-c947-401d-a8e1-48c943f17cfc_bottom",
      "7525a5d2-c947-401d-a8e1-48c943f17cfc_left",
      "7525a5d2-c947-401d-a8e1-48c943f17cfc_right",
      "7525a5d2-c947-401d-a8e1-48c943f17cfc_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "7525a5d2-c947-401d-a8e1-48c943f17cfc_bottom": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "7525a5d2-c947-401d-a8e1-48c943f17cfc_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "7525a5d2-c947-401d-a8e1-48c943f17cfc_right": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "7525a5d2-c947-401d-a8e1-48c943f17cfc_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "7681e420-6306-46ca-beb7-01e412b24005": {
    "has_axis": [
      "7681e420-6306-46ca-beb7-01e412b24005_bottom",
      "7681e420-6306-46ca-beb7-01e412b24005_left",
      "7681e420-6306-46ca-beb7-01e412b24005_right",
      "7681e420-6306-46ca-beb7-01e412b24005_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "7681e420-6306-46ca-beb7-01e412b24005_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "7681e420-6306-46ca-beb7-01e412b24005_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "7681e420-6306-46ca-beb7-01e412b24005_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "7681e420-6306-46ca-beb7-01e412b24005_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "78d0caee-a319-44ee-8e7c-c15bac97cfac": {
    "has_axis": [
      "78d0caee-a319-44ee-8e7c-c15bac97cfac_bottom",
      "78d0caee-a319-44ee-8e7c-c15bac97cfac_left",
      "78d0caee-a319-44ee-8e7c-c15bac97cfac_right",
      "78d0caee-a319-44ee-8e7c-c15bac97cfac_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "78d0caee-a319-44ee-8e7c-c15bac97cfac_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom"
    ]
  },
  "78d0caee-a319-44ee-8e7c-c15bac97cfac_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "78d0caee-a319-44ee-8e7c-c15bac97cfac_right": {
    "is_limited_by": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_right"
    ]
  },
  "78d0caee-a319-44ee-8e7c-c15bac97cfac_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "797017cb-2846-4bb7-b45a-ad16dc72fe4e": {
    "has_axis": [
      "797017cb-2846-4bb7-b45a-ad16dc72fe4e_bottom",
      "797017cb-2846-4bb7-b45a-ad16dc72fe4e_left",
      "797017cb-2846-4bb7-b45a-ad16dc72fe4e_right",
      "797017cb-2846-4bb7-b45a-ad16dc72fe4e_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "797017cb-2846-4bb7-b45a-ad16dc72fe4e_bottom": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ]
  },
  "797017cb-2846-4bb7-b45a-ad16dc72fe4e_left": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left"
    ]
  },
  "797017cb-2846-4bb7-b45a-ad16dc72fe4e_right": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left"
    ]
  },
  "797017cb-2846-4bb7-b45a-ad16dc72fe4e_top": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ]
  },
  "79ec29c4-a287-49aa-8ac4-eae4d134da1d": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "79ec29c4-a287-49aa-8ac4-eae4d134da1d_bottom",
      "79ec29c4-a287-49aa-8ac4-eae4d134da1d_left",
      "79ec29c4-a287-49aa-8ac4-eae4d134da1d_right",
      "79ec29c4-a287-49aa-8ac4-eae4d134da1d_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "79ec29c4-a287-49aa-8ac4-eae4d134da1d_bottom": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_bottom"
    ]
  },
  "79ec29c4-a287-49aa-8ac4-eae4d134da1d_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "79ec29c4-a287-49aa-8ac4-eae4d134da1d_right": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_right"
    ]
  },
  "79ec29c4-a287-49aa-8ac4-eae4d134da1d_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "7b210f71-5928-466e-aa4d-02ae284e2989": {
    "has_axis": [
      "7b210f71-5928-466e-aa4d-02ae284e2989_bottom",
      "7b210f71-5928-466e-aa4d-02ae284e2989_left",
      "7b210f71-5928-466e-aa4d-02ae284e2989_right",
      "7b210f71-5928-466e-aa4d-02ae284e2989_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "7b210f71-5928-466e-aa4d-02ae284e2989_bottom": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ]
  },
  "7b210f71-5928-466e-aa4d-02ae284e2989_left": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left"
    ]
  },
  "7b210f71-5928-466e-aa4d-02ae284e2989_right": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left"
    ]
  },
  "7b210f71-5928-466e-aa4d-02ae284e2989_top": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ]
  },
  "7bcd56a6-c2e8-405a-81a1-e39e024c91b7": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_bottom",
      "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_left",
      "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_right",
      "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_bottom": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_bottom"
    ]
  },
  "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_right": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_right"
    ]
  },
  "7bcd56a6-c2e8-405a-81a1-e39e024c91b7_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "7c4b5d08-8553-45f3-9c92-ac37aa897690": {
    "has_axis": [
      "7c4b5d08-8553-45f3-9c92-ac37aa897690_bottom",
      "7c4b5d08-8553-45f3-9c92-ac37aa897690_left",
      "7c4b5d08-8553-45f3-9c92-ac37aa897690_right",
      "7c4b5d08-8553-45f3-9c92-ac37aa897690_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "7c4b5d08-8553-45f3-9c92-ac37aa897690_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "7c4b5d08-8553-45f3-9c92-ac37aa897690_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "7c4b5d08-8553-45f3-9c92-ac37aa897690_right": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "7c4b5d08-8553-45f3-9c92-ac37aa897690_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "7e257dc0-6bf2-425b-9156-290223f6981f": {
    "has_axis": [
      "7e257dc0-6bf2-425b-9156-290223f6981f_bottom",
      "7e257dc0-6bf2-425b-9156-290223f6981f_left",
      "7e257dc0-6bf2-425b-9156-290223f6981f_right",
      "7e257dc0-6bf2-425b-9156-290223f6981f_top"
    ],
    "has_role": [
      "custom:logo"
    ],
    "is_a": [
      "image"
    ]
  },
  "7e257dc0-6bf2-425b-9156-290223f6981f_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "7e257dc0-6bf2-425b-9156-290223f6981f_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "7e257dc0-6bf2-425b-9156-290223f6981f_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "7e257dc0-6bf2-425b-9156-290223f6981f_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "825eca02-f797-4734-8db9-23a087f2ed2e": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "85f25280-8989-4be3-b16c-6e9d22d9b6c1": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "85f25280-8989-4be3-b16c-6e9d22d9b6c1_bottom",
      "85f25280-8989-4be3-b16c-6e9d22d9b6c1_left",
      "85f25280-8989-4be3-b16c-6e9d22d9b6c1_right",
      "85f25280-8989-4be3-b16c-6e9d22d9b6c1_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "85f25280-8989-4be3-b16c-6e9d22d9b6c1_bottom": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_bottom"
    ]
  },
  "85f25280-8989-4be3-b16c-6e9d22d9b6c1_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "85f25280-8989-4be3-b16c-6e9d22d9b6c1_right": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_right"
    ]
  },
  "85f25280-8989-4be3-b16c-6e9d22d9b6c1_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "8a56399c-4fc2-4e72-a798-bd90aeb417c9": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "8a56399c-4fc2-4e72-a798-bd90aeb417c9_bottom",
      "8a56399c-4fc2-4e72-a798-bd90aeb417c9_left",
      "8a56399c-4fc2-4e72-a798-bd90aeb417c9_right",
      "8a56399c-4fc2-4e72-a798-bd90aeb417c9_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "8a56399c-4fc2-4e72-a798-bd90aeb417c9_bottom": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom"
    ]
  },
  "8a56399c-4fc2-4e72-a798-bd90aeb417c9_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "8a56399c-4fc2-4e72-a798-bd90aeb417c9_right": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_right"
    ]
  },
  "8a56399c-4fc2-4e72-a798-bd90aeb417c9_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "8b29d36e-1120-43cc-9781-0354be720c2b": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "8b77414d-a542-4222-acb0-a1b90d184d69": {
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "8c253f46-2c3c-4db4-8860-8a02f9ccfde7": {
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "8c715784-9caa-4cac-9273-9260ed88a96f": {
    "has_axis": [
      "8c715784-9caa-4cac-9273-9260ed88a96f_bottom",
      "8c715784-9caa-4cac-9273-9260ed88a96f_left",
      "8c715784-9caa-4cac-9273-9260ed88a96f_right",
      "8c715784-9caa-4cac-9273-9260ed88a96f_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "8c715784-9caa-4cac-9273-9260ed88a96f_bottom": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_top"
    ]
  },
  "8c715784-9caa-4cac-9273-9260ed88a96f_left": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_left"
    ]
  },
  "8c715784-9caa-4cac-9273-9260ed88a96f_right": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_left"
    ]
  },
  "8c715784-9caa-4cac-9273-9260ed88a96f_top": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_top"
    ]
  },
  "8ca27b0f-d10e-4d35-912b-969e99e37aec": {
    "contains": [
      "0a74fb54-1b31-46d6-a8b8-e13c292e8069",
      "14ee8467-275d-47eb-8252-74dde64e8179",
      "29c6b33a-e04d-444b-a462-d25e577832ff",
      "999ff148-dd0a-4654-96fb-ec416264c291",
      "9fcc2418-7096-4121-afdc-9200591e4b47",
      "b2721d84-2f2f-4d25-b8fa-92d013ef113a",
      "d5e2ffce-71cb-44ea-90ca-99ac466c73a2",
      "deddf272-f102-4a15-851b-57b446f88245",
      "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08"
    ],
    "has_axis": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom",
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left",
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_right",
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ],
    "has_role": [
      "small_title"
    ],
    "is_a": [
      "slide"
    ]
  },
  "8ee09d28-eea9-4088-a564-03a5a46f2f20": {
    "has_axis": [
      "8ee09d28-eea9-4088-a564-03a5a46f2f20_bottom",
      "8ee09d28-eea9-4088-a564-03a5a46f2f20_left",
      "8ee09d28-eea9-4088-a564-03a5a46f2f20_right",
      "8ee09d28-eea9-4088-a564-03a5a46f2f20_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "8ee09d28-eea9-4088-a564-03a5a46f2f20_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "8ee09d28-eea9-4088-a564-03a5a46f2f20_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "8ee09d28-eea9-4088-a564-03a5a46f2f20_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "8ee09d28-eea9-4088-a564-03a5a46f2f20_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "9319ba0d-afcf-4507-84ad-0028651706d4": {
    "has_axis": [
      "9319ba0d-afcf-4507-84ad-0028651706d4_bottom",
      "9319ba0d-afcf-4507-84ad-0028651706d4_bottom_offset_-32",
      "9319ba0d-afcf-4507-84ad-0028651706d4_left",
      "9319ba0d-afcf-4507-84ad-0028651706d4_right",
      "9319ba0d-afcf-4507-84ad-0028651706d4_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "9319ba0d-afcf-4507-84ad-0028651706d4_bottom": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "9319ba0d-afcf-4507-84ad-0028651706d4_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "9319ba0d-afcf-4507-84ad-0028651706d4_right": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "9319ba0d-afcf-4507-84ad-0028651706d4_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "965ef0ae-a185-4971-9193-c5ee4046085f": {
    "is_a": [
      "image"
    ]
  },
  "98743a8c-2f78-488b-b954-f09081e57d2a": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "98743a8c-2f78-488b-b954-f09081e57d2a_bottom",
      "98743a8c-2f78-488b-b954-f09081e57d2a_left",
      "98743a8c-2f78-488b-b954-f09081e57d2a_right",
      "98743a8c-2f78-488b-b954-f09081e57d2a_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "text"
    ]
  },
  "98743a8c-2f78-488b-b954-f09081e57d2a_bottom": {
    "is_limited_by": [
      "2342c752-7b06-4b38-84a8-6adc01291aed_top"
    ]
  },
  "98743a8c-2f78-488b-b954-f09081e57d2a_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "98743a8c-2f78-488b-b954-f09081e57d2a_right": {
    "is_limited_by": [
      "2342c752-7b06-4b38-84a8-6adc01291aed_left_offset_-32"
    ]
  },
  "98743a8c-2f78-488b-b954-f09081e57d2a_top": {
    "is_pinned_to": [
      "a2d3b917-7f07-46f1-991c-97273ee3275c_bottom"
    ]
  },
  "999ff148-dd0a-4654-96fb-ec416264c291": {
    "has_axis": [
      "999ff148-dd0a-4654-96fb-ec416264c291_bottom",
      "999ff148-dd0a-4654-96fb-ec416264c291_bottom_offset_-32",
      "999ff148-dd0a-4654-96fb-ec416264c291_left",
      "999ff148-dd0a-4654-96fb-ec416264c291_right",
      "999ff148-dd0a-4654-96fb-ec416264c291_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "999ff148-dd0a-4654-96fb-ec416264c291_bottom": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "999ff148-dd0a-4654-96fb-ec416264c291_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "999ff148-dd0a-4654-96fb-ec416264c291_right": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "999ff148-dd0a-4654-96fb-ec416264c291_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "9b0f28ba-748a-4112-84e4-65335022c8de": {
    "has_axis": [
      "9b0f28ba-748a-4112-84e4-65335022c8de_bottom",
      "9b0f28ba-748a-4112-84e4-65335022c8de_left",
      "9b0f28ba-748a-4112-84e4-65335022c8de_right",
      "9b0f28ba-748a-4112-84e4-65335022c8de_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "9b0f28ba-748a-4112-84e4-65335022c8de_bottom": {
    "is_pinned_to": [
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b_top"
    ]
  },
  "9b0f28ba-748a-4112-84e4-65335022c8de_left": {
    "is_pinned_to": [
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b_left"
    ]
  },
  "9b0f28ba-748a-4112-84e4-65335022c8de_right": {
    "is_pinned_to": [
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b_left"
    ]
  },
  "9b0f28ba-748a-4112-84e4-65335022c8de_top": {
    "is_pinned_to": [
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b_top"
    ]
  },
  "9b62394d-e882-4b32-8673-9a6663063d0f": {
    "contains": [
      "4574aea6-3b0d-4e30-aa06-fdcb420a34d0",
      "640f3598-52e6-4d5d-929e-1357754b5b2a",
      "676d177d-0f68-4da3-9fff-575c0ca96cef",
      "7525a5d2-c947-401d-a8e1-48c943f17cfc",
      "7bcd56a6-c2e8-405a-81a1-e39e024c91b7",
      "9c8a5495-5726-4df4-b098-40a0456b8170",
      "9efd4120-5fef-4551-a1d0-cc41a3f0a930",
      "c9964581-93bf-4bcb-8513-060272c26759"
    ],
    "has_axis": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_bottom",
      "9b62394d-e882-4b32-8673-9a6663063d0f_left",
      "9b62394d-e882-4b32-8673-9a6663063d0f_right",
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ],
    "has_role": [
      "agenda"
    ],
    "is_a": [
      "slide"
    ]
  },
  "9b6abe86-24f1-4829-9eb1-8b49293dc09b": {
    "has_axis": [
      "9b6abe86-24f1-4829-9eb1-8b49293dc09b_bottom",
      "9b6abe86-24f1-4829-9eb1-8b49293dc09b_left",
      "9b6abe86-24f1-4829-9eb1-8b49293dc09b_right",
      "9b6abe86-24f1-4829-9eb1-8b49293dc09b_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "9b6abe86-24f1-4829-9eb1-8b49293dc09b_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "9b6abe86-24f1-4829-9eb1-8b49293dc09b_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "9b6abe86-24f1-4829-9eb1-8b49293dc09b_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "9b6abe86-24f1-4829-9eb1-8b49293dc09b_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "9c1f6c13-a362-42ef-907c-b9fec7b4041f": {
    "has_axis": [
      "9c1f6c13-a362-42ef-907c-b9fec7b4041f_bottom",
      "9c1f6c13-a362-42ef-907c-b9fec7b4041f_left",
      "9c1f6c13-a362-42ef-907c-b9fec7b4041f_right",
      "9c1f6c13-a362-42ef-907c-b9fec7b4041f_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "9c1f6c13-a362-42ef-907c-b9fec7b4041f_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "9c1f6c13-a362-42ef-907c-b9fec7b4041f_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "9c1f6c13-a362-42ef-907c-b9fec7b4041f_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "9c1f6c13-a362-42ef-907c-b9fec7b4041f_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "9c8a5495-5726-4df4-b098-40a0456b8170": {
    "has_axis": [
      "9c8a5495-5726-4df4-b098-40a0456b8170_bottom",
      "9c8a5495-5726-4df4-b098-40a0456b8170_left",
      "9c8a5495-5726-4df4-b098-40a0456b8170_right",
      "9c8a5495-5726-4df4-b098-40a0456b8170_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "9c8a5495-5726-4df4-b098-40a0456b8170_bottom": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "9c8a5495-5726-4df4-b098-40a0456b8170_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "9c8a5495-5726-4df4-b098-40a0456b8170_right": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "9c8a5495-5726-4df4-b098-40a0456b8170_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "9cc1b7db-35bb-4ad1-b4f2-47943e535418": {
    "contains": [
      "061bbcd0-e9c1-4988-a030-5f21b0570f76",
      "0e4730ae-e29b-4e31-9cde-682868356ae9",
      "1dc8a7d1-059f-4740-8ad8-5268f85ed647",
      "1f501127-fe01-4a44-afa6-4b53f5a40be4",
      "26c813bc-f7c7-46e4-9ad2-e002d07208d4",
      "3a6eb667-0bd1-462a-a3ff-63fadc096926",
      "3c81a404-ffbb-40ff-8a55-2d1a6a7de35d",
      "6413dc3d-e450-4649-9bc9-5b590d6ddd06",
      "6ddf3890-7cba-4470-bb02-2321ac7f7a77",
      "78d0caee-a319-44ee-8e7c-c15bac97cfac",
      "7c4b5d08-8553-45f3-9c92-ac37aa897690",
      "ae2d10d9-4a8a-41ed-bab2-447cd68009de",
      "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43",
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89",
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10",
      "ee557a2e-b3e7-40ae-a78f-486bc1693d8f"
    ],
    "has_axis": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom",
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left",
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_right",
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "slide"
    ]
  },
  "9d9178a3-2555-4ff5-8b03-902fbf8aca69": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "text"
    ]
  },
  "9d9393e6-aad4-4eb9-8793-2332fadc592f": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "9d9393e6-aad4-4eb9-8793-2332fadc592f_bottom",
      "9d9393e6-aad4-4eb9-8793-2332fadc592f_left",
      "9d9393e6-aad4-4eb9-8793-2332fadc592f_right",
      "9d9393e6-aad4-4eb9-8793-2332fadc592f_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "9d9393e6-aad4-4eb9-8793-2332fadc592f_bottom": {
    "is_limited_by": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_bottom"
    ]
  },
  "9d9393e6-aad4-4eb9-8793-2332fadc592f_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "9d9393e6-aad4-4eb9-8793-2332fadc592f_right": {
    "is_limited_by": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_right"
    ]
  },
  "9d9393e6-aad4-4eb9-8793-2332fadc592f_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "9ea59f27-7ca5-47b3-aab2-727a7de631f7": {
    "contains": [
      "0e5c3389-b4ca-4ffe-9347-a5d1280df7db",
      "2c989e52-7716-43e9-85d9-d08dcd08cb43",
      "5f52d182-db39-48d5-9ea0-24d231fad72b",
      "7e257dc0-6bf2-425b-9156-290223f6981f",
      "badf6210-5022-4590-90b0-5961c1e0a0c8",
      "c953951d-3b19-443b-9c8d-a201eab6708e",
      "d9e49dd8-5249-49af-9b1a-d4be5e2e9953",
      "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871",
      "ecee4b97-e77a-4a46-9d81-e353eb45199b",
      "ef87ed0b-1977-45e7-9ce9-2bb509ceceba",
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d",
      "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5"
    ],
    "has_axis": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom",
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left",
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_right",
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ],
    "has_role": [
      "custom:personaIntroduction"
    ],
    "is_a": [
      "slide"
    ]
  },
  "9efd4120-5fef-4551-a1d0-cc41a3f0a930": {
    "has_axis": [
      "9efd4120-5fef-4551-a1d0-cc41a3f0a930_bottom",
      "9efd4120-5fef-4551-a1d0-cc41a3f0a930_left",
      "9efd4120-5fef-4551-a1d0-cc41a3f0a930_right",
      "9efd4120-5fef-4551-a1d0-cc41a3f0a930_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "9efd4120-5fef-4551-a1d0-cc41a3f0a930_bottom": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "9efd4120-5fef-4551-a1d0-cc41a3f0a930_left": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "9efd4120-5fef-4551-a1d0-cc41a3f0a930_right": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "9efd4120-5fef-4551-a1d0-cc41a3f0a930_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "9fcc2418-7096-4121-afdc-9200591e4b47": {
    "has_axis": [
      "9fcc2418-7096-4121-afdc-9200591e4b47_bottom",
      "9fcc2418-7096-4121-afdc-9200591e4b47_left",
      "9fcc2418-7096-4121-afdc-9200591e4b47_right",
      "9fcc2418-7096-4121-afdc-9200591e4b47_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "9fcc2418-7096-4121-afdc-9200591e4b47_bottom": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "9fcc2418-7096-4121-afdc-9200591e4b47_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "9fcc2418-7096-4121-afdc-9200591e4b47_right": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "9fcc2418-7096-4121-afdc-9200591e4b47_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "a15c5b64-2636-47f3-8544-1ce6f29a62a7": {
    "has_axis": [
      "a15c5b64-2636-47f3-8544-1ce6f29a62a7_bottom",
      "a15c5b64-2636-47f3-8544-1ce6f29a62a7_left",
      "a15c5b64-2636-47f3-8544-1ce6f29a62a7_right",
      "a15c5b64-2636-47f3-8544-1ce6f29a62a7_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "a15c5b64-2636-47f3-8544-1ce6f29a62a7_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "a15c5b64-2636-47f3-8544-1ce6f29a62a7_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "a15c5b64-2636-47f3-8544-1ce6f29a62a7_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "a15c5b64-2636-47f3-8544-1ce6f29a62a7_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "a2d3b917-7f07-46f1-991c-97273ee3275c": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "a2d3b917-7f07-46f1-991c-97273ee3275c_bottom",
      "a2d3b917-7f07-46f1-991c-97273ee3275c_left",
      "a2d3b917-7f07-46f1-991c-97273ee3275c_right",
      "a2d3b917-7f07-46f1-991c-97273ee3275c_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "a2d3b917-7f07-46f1-991c-97273ee3275c_bottom": {
    "is_limited_by": [
      "2342c752-7b06-4b38-84a8-6adc01291aed_top_offset_-32"
    ]
  },
  "a2d3b917-7f07-46f1-991c-97273ee3275c_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "a2d3b917-7f07-46f1-991c-97273ee3275c_right": {
    "is_limited_by": [
      "60389d63-842f-48e8-9536-ce2404aaf2bf_left_offset_-32"
    ]
  },
  "a2d3b917-7f07-46f1-991c-97273ee3275c_top": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "ab0eb597-2dcd-4869-b761-f22f2e514dd4": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "ac2db977-a249-4092-9cdc-2e4893e64abd": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "ac2db977-a249-4092-9cdc-2e4893e64abd_bottom",
      "ac2db977-a249-4092-9cdc-2e4893e64abd_left",
      "ac2db977-a249-4092-9cdc-2e4893e64abd_right",
      "ac2db977-a249-4092-9cdc-2e4893e64abd_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "ac2db977-a249-4092-9cdc-2e4893e64abd_bottom": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom"
    ]
  },
  "ac2db977-a249-4092-9cdc-2e4893e64abd_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "ac2db977-a249-4092-9cdc-2e4893e64abd_right": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_right"
    ]
  },
  "ac2db977-a249-4092-9cdc-2e4893e64abd_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "ad3af027-0fdb-40dd-99de-93a1cc60f8bd": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_bottom",
      "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_left",
      "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_right",
      "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_bottom": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_bottom"
    ]
  },
  "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_right": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_right"
    ]
  },
  "ad3af027-0fdb-40dd-99de-93a1cc60f8bd_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "ae2d10d9-4a8a-41ed-bab2-447cd68009de": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_role": [
      "custom:personaName"
    ],
    "is_a": [
      "text"
    ]
  },
  "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd": {
    "has_axis": [
      "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_bottom",
      "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_left",
      "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_right",
      "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "af8ab741-e916-43d1-9956-e1d0ab5d3a2f": {
    "contains": [
      "4b7caf30-116b-4384-9028-d352fefc571d",
      "6a2513b9-c09b-484e-896f-398b1a5e8a36",
      "6d8d7dd5-b88c-4f34-ab46-b28fc765d86d",
      "797017cb-2846-4bb7-b45a-ad16dc72fe4e",
      "8b29d36e-1120-43cc-9781-0354be720c2b",
      "965ef0ae-a185-4971-9193-c5ee4046085f",
      "cf642c3c-49b0-4db0-8733-4456bdb53802",
      "d196b390-2f75-4128-a6c7-cec47bfbe978",
      "e14cef1a-641e-4ea2-9516-ca9974f54082",
      "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea"
    ],
    "has_axis": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left",
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ],
    "is_a": [
      "slide"
    ]
  },
  "b1ce999b-d48a-4170-8b0f-13cc24f073c4": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "b1ce999b-d48a-4170-8b0f-13cc24f073c4_bottom",
      "b1ce999b-d48a-4170-8b0f-13cc24f073c4_left",
      "b1ce999b-d48a-4170-8b0f-13cc24f073c4_right",
      "b1ce999b-d48a-4170-8b0f-13cc24f073c4_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "b1ce999b-d48a-4170-8b0f-13cc24f073c4_bottom": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_bottom"
    ]
  },
  "b1ce999b-d48a-4170-8b0f-13cc24f073c4_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "b1ce999b-d48a-4170-8b0f-13cc24f073c4_right": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_right"
    ]
  },
  "b1ce999b-d48a-4170-8b0f-13cc24f073c4_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "b2721d84-2f2f-4d25-b8fa-92d013ef113a": {
    "has_axis": [
      "b2721d84-2f2f-4d25-b8fa-92d013ef113a_bottom",
      "b2721d84-2f2f-4d25-b8fa-92d013ef113a_left",
      "b2721d84-2f2f-4d25-b8fa-92d013ef113a_right",
      "b2721d84-2f2f-4d25-b8fa-92d013ef113a_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "b2721d84-2f2f-4d25-b8fa-92d013ef113a_bottom": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "b2721d84-2f2f-4d25-b8fa-92d013ef113a_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "b2721d84-2f2f-4d25-b8fa-92d013ef113a_right": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "b2721d84-2f2f-4d25-b8fa-92d013ef113a_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "b404b6c6-e93d-4fd2-acab-6acd258a6835": {
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "b60587e5-64df-4c1c-849f-520a5a84c296": {
    "has_axis": [
      "b60587e5-64df-4c1c-849f-520a5a84c296_bottom",
      "b60587e5-64df-4c1c-849f-520a5a84c296_left",
      "b60587e5-64df-4c1c-849f-520a5a84c296_right",
      "b60587e5-64df-4c1c-849f-520a5a84c296_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "b60587e5-64df-4c1c-849f-520a5a84c296_bottom": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ]
  },
  "b60587e5-64df-4c1c-849f-520a5a84c296_left": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left"
    ]
  },
  "b60587e5-64df-4c1c-849f-520a5a84c296_right": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left"
    ]
  },
  "b60587e5-64df-4c1c-849f-520a5a84c296_top": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ]
  },
  "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_bottom",
      "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_left",
      "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_right",
      "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "text"
    ]
  },
  "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_bottom": {
    "is_limited_by": [
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_top_offset_-32"
    ]
  },
  "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_right": {
    "is_limited_by": [
      "26c813bc-f7c7-46e4-9ad2-e002d07208d4_left_offset_-32"
    ]
  },
  "b8f2c2c3-74f5-45dd-ac71-fa50c58b4e43_top": {
    "is_pinned_to": [
      "6ddf3890-7cba-4470-bb02-2321ac7f7a77_bottom"
    ]
  },
  "b9a08d48-67d9-40b3-ad53-45a81895ab9b": {
    "has_axis": [
      "b9a08d48-67d9-40b3-ad53-45a81895ab9b_bottom",
      "b9a08d48-67d9-40b3-ad53-45a81895ab9b_left",
      "b9a08d48-67d9-40b3-ad53-45a81895ab9b_right",
      "b9a08d48-67d9-40b3-ad53-45a81895ab9b_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "b9a08d48-67d9-40b3-ad53-45a81895ab9b_bottom": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "b9a08d48-67d9-40b3-ad53-45a81895ab9b_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "b9a08d48-67d9-40b3-ad53-45a81895ab9b_right": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "b9a08d48-67d9-40b3-ad53-45a81895ab9b_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "ba4fd689-f519-411d-9f85-e7f440e22ec4": {
    "has_axis": [
      "ba4fd689-f519-411d-9f85-e7f440e22ec4_bottom",
      "ba4fd689-f519-411d-9f85-e7f440e22ec4_left",
      "ba4fd689-f519-411d-9f85-e7f440e22ec4_right",
      "ba4fd689-f519-411d-9f85-e7f440e22ec4_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "ba4fd689-f519-411d-9f85-e7f440e22ec4_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "ba4fd689-f519-411d-9f85-e7f440e22ec4_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "ba4fd689-f519-411d-9f85-e7f440e22ec4_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "ba4fd689-f519-411d-9f85-e7f440e22ec4_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "badf6210-5022-4590-90b0-5961c1e0a0c8": {
    "has_axis": [
      "badf6210-5022-4590-90b0-5961c1e0a0c8_bottom",
      "badf6210-5022-4590-90b0-5961c1e0a0c8_left",
      "badf6210-5022-4590-90b0-5961c1e0a0c8_right",
      "badf6210-5022-4590-90b0-5961c1e0a0c8_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "badf6210-5022-4590-90b0-5961c1e0a0c8_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "badf6210-5022-4590-90b0-5961c1e0a0c8_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "badf6210-5022-4590-90b0-5961c1e0a0c8_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "badf6210-5022-4590-90b0-5961c1e0a0c8_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "bce10be2-b9a8-4cca-91f5-8d7dc3141009": {
    "is_a": [
      "image"
    ]
  },
  "bd369631-a068-494a-9084-0b4bdb7312f5": {
    "has_axis": [
      "bd369631-a068-494a-9084-0b4bdb7312f5_bottom",
      "bd369631-a068-494a-9084-0b4bdb7312f5_left",
      "bd369631-a068-494a-9084-0b4bdb7312f5_right",
      "bd369631-a068-494a-9084-0b4bdb7312f5_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "bd369631-a068-494a-9084-0b4bdb7312f5_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "bd369631-a068-494a-9084-0b4bdb7312f5_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "bd369631-a068-494a-9084-0b4bdb7312f5_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "bd369631-a068-494a-9084-0b4bdb7312f5_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "c04a832d-36f6-400b-8fd5-fbff24acb317": {
    "has_axis": [
      "c04a832d-36f6-400b-8fd5-fbff24acb317_bottom",
      "c04a832d-36f6-400b-8fd5-fbff24acb317_left",
      "c04a832d-36f6-400b-8fd5-fbff24acb317_right",
      "c04a832d-36f6-400b-8fd5-fbff24acb317_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "c04a832d-36f6-400b-8fd5-fbff24acb317_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "c04a832d-36f6-400b-8fd5-fbff24acb317_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "c04a832d-36f6-400b-8fd5-fbff24acb317_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "c04a832d-36f6-400b-8fd5-fbff24acb317_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "c1cb59a2-1fbd-400d-95da-2139af7f464d": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "c1cb59a2-1fbd-400d-95da-2139af7f464d_bottom",
      "c1cb59a2-1fbd-400d-95da-2139af7f464d_left",
      "c1cb59a2-1fbd-400d-95da-2139af7f464d_right",
      "c1cb59a2-1fbd-400d-95da-2139af7f464d_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "c1cb59a2-1fbd-400d-95da-2139af7f464d_bottom": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_bottom"
    ]
  },
  "c1cb59a2-1fbd-400d-95da-2139af7f464d_left": {
    "is_limited_by": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "c1cb59a2-1fbd-400d-95da-2139af7f464d_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "c1cb59a2-1fbd-400d-95da-2139af7f464d_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "c39209f9-2bd4-4052-9c3c-5e18c5be0d11": {
    "contains": [
      "0e3cc635-21ea-42f2-b03c-81d94dea1202",
      "105a38cf-643c-4c9e-9eb7-9a266559c7b5",
      "16f01b56-5e50-4aba-8a4d-04202d4aa796",
      "1b8e67c5-8972-4f37-bc8e-2431e93e627d",
      "4419dc06-5ce3-4f8d-bdb4-3ded07ac6bc0",
      "5feed6ff-1382-46bc-ae1f-713609ac0045",
      "7681e420-6306-46ca-beb7-01e412b24005",
      "8b77414d-a542-4222-acb0-a1b90d184d69",
      "8ee09d28-eea9-4088-a564-03a5a46f2f20",
      "9d9178a3-2555-4ff5-8b03-902fbf8aca69",
      "9d9393e6-aad4-4eb9-8793-2332fadc592f",
      "ae70180a-c6ec-4b12-94d2-3bbc6e8a02fd",
      "b404b6c6-e93d-4fd2-acab-6acd258a6835",
      "cc630350-c0bc-4fd3-a93d-bc7d54d0c06f",
      "e00ca332-09bf-4da6-b1c4-31e1324b5b7f",
      "f2161dbc-a064-46a0-aa86-4a848d9d3940"
    ],
    "has_axis": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_bottom",
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left",
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_right",
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ],
    "is_a": [
      "slide"
    ]
  },
  "c403034c-0a73-49a8-9539-7e5352f740c5": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "c403034c-0a73-49a8-9539-7e5352f740c5_bottom",
      "c403034c-0a73-49a8-9539-7e5352f740c5_left",
      "c403034c-0a73-49a8-9539-7e5352f740c5_right",
      "c403034c-0a73-49a8-9539-7e5352f740c5_top"
    ],
    "has_role": [
      "title"
    ],
    "is_a": [
      "text"
    ]
  },
  "c403034c-0a73-49a8-9539-7e5352f740c5_bottom": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_bottom"
    ]
  },
  "c403034c-0a73-49a8-9539-7e5352f740c5_left": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_left"
    ]
  },
  "c403034c-0a73-49a8-9539-7e5352f740c5_right": {
    "is_limited_by": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_right"
    ]
  },
  "c403034c-0a73-49a8-9539-7e5352f740c5_top": {
    "is_pinned_to": [
      "3c566718-4899-439f-bac4-3c58a81f1aa7_top"
    ]
  },
  "c5db5a31-0736-4a67-9d6d-4e7921a09d89": {
    "has_axis": [
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89_bottom",
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89_left",
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89_left_offset_-32",
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89_right",
      "c5db5a31-0736-4a67-9d6d-4e7921a09d89_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "image"
    ]
  },
  "c5db5a31-0736-4a67-9d6d-4e7921a09d89_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom"
    ]
  },
  "c5db5a31-0736-4a67-9d6d-4e7921a09d89_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "c5db5a31-0736-4a67-9d6d-4e7921a09d89_right": {
    "is_limited_by": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_right"
    ]
  },
  "c5db5a31-0736-4a67-9d6d-4e7921a09d89_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "c953951d-3b19-443b-9c8d-a201eab6708e": {
    "has_axis": [
      "c953951d-3b19-443b-9c8d-a201eab6708e_bottom",
      "c953951d-3b19-443b-9c8d-a201eab6708e_left",
      "c953951d-3b19-443b-9c8d-a201eab6708e_right",
      "c953951d-3b19-443b-9c8d-a201eab6708e_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "c953951d-3b19-443b-9c8d-a201eab6708e_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "c953951d-3b19-443b-9c8d-a201eab6708e_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "c953951d-3b19-443b-9c8d-a201eab6708e_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "c953951d-3b19-443b-9c8d-a201eab6708e_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "c9964581-93bf-4bcb-8513-060272c26759": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "c9964581-93bf-4bcb-8513-060272c26759_bottom",
      "c9964581-93bf-4bcb-8513-060272c26759_left",
      "c9964581-93bf-4bcb-8513-060272c26759_right",
      "c9964581-93bf-4bcb-8513-060272c26759_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "c9964581-93bf-4bcb-8513-060272c26759_bottom": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_bottom"
    ]
  },
  "c9964581-93bf-4bcb-8513-060272c26759_left": {
    "is_limited_by": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "c9964581-93bf-4bcb-8513-060272c26759_right": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_left"
    ]
  },
  "c9964581-93bf-4bcb-8513-060272c26759_top": {
    "is_pinned_to": [
      "9b62394d-e882-4b32-8673-9a6663063d0f_top"
    ]
  },
  "cbf21645-b078-4812-b755-d8ecae9ef204": {
    "has_axis": [
      "cbf21645-b078-4812-b755-d8ecae9ef204_bottom",
      "cbf21645-b078-4812-b755-d8ecae9ef204_left",
      "cbf21645-b078-4812-b755-d8ecae9ef204_right",
      "cbf21645-b078-4812-b755-d8ecae9ef204_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "cbf21645-b078-4812-b755-d8ecae9ef204_bottom": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_top"
    ]
  },
  "cbf21645-b078-4812-b755-d8ecae9ef204_left": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_left"
    ]
  },
  "cbf21645-b078-4812-b755-d8ecae9ef204_right": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_left"
    ]
  },
  "cbf21645-b078-4812-b755-d8ecae9ef204_top": {
    "is_pinned_to": [
      "731d57c9-7588-4ca3-a019-5618a436794a_top"
    ]
  },
  "cc630350-c0bc-4fd3-a93d-bc7d54d0c06f": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "text"
    ]
  },
  "ccf00a0f-8a27-4c3b-8119-b2f8b7723469": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_bottom",
      "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_left",
      "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_right",
      "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_bottom": {
    "is_limited_by": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_bottom"
    ]
  },
  "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_right": {
    "is_limited_by": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_right"
    ]
  },
  "ccf00a0f-8a27-4c3b-8119-b2f8b7723469_top": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "cdf1a5fe-5790-4150-a208-8bdfc2381c10": {
    "has_axis": [
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_bottom",
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_left",
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_right",
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_top",
      "cdf1a5fe-5790-4150-a208-8bdfc2381c10_top_offset_-32"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "cdf1a5fe-5790-4150-a208-8bdfc2381c10_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "cdf1a5fe-5790-4150-a208-8bdfc2381c10_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "cdf1a5fe-5790-4150-a208-8bdfc2381c10_right": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "cdf1a5fe-5790-4150-a208-8bdfc2381c10_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "cf642c3c-49b0-4db0-8733-4456bdb53802": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "content-f4d39f7f-eb69-4e8f-9c80-a0c479345826": {
    "has_role": [
      "content"
    ],
    "is_a": [
      "list_item"
    ]
  },
  "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_bottom",
      "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_left",
      "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_right",
      "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_bottom": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom"
    ]
  },
  "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_right": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_right"
    ]
  },
  "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "d196b390-2f75-4128-a6c7-cec47bfbe978": {
    "is_a": [
      "image"
    ]
  },
  "d5e2ffce-71cb-44ea-90ca-99ac466c73a2": {
    "has_axis": [
      "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_bottom",
      "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_left",
      "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_right",
      "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_top"
    ],
    "has_role": [
      "background"
    ],
    "is_a": [
      "image"
    ]
  },
  "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_bottom": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_right": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "d5e2ffce-71cb-44ea-90ca-99ac466c73a2_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "d8785e68-1271-4aac-8746-620d93c73b1e": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "d8785e68-1271-4aac-8746-620d93c73b1e_bottom",
      "d8785e68-1271-4aac-8746-620d93c73b1e_left",
      "d8785e68-1271-4aac-8746-620d93c73b1e_right",
      "d8785e68-1271-4aac-8746-620d93c73b1e_top"
    ],
    "has_role": [
      "subtitle"
    ],
    "is_a": [
      "text"
    ]
  },
  "d8785e68-1271-4aac-8746-620d93c73b1e_bottom": {
    "is_limited_by": [
      "152bfeb9-aa0c-42cf-b639-d3f63556df80_bottom"
    ]
  },
  "d8785e68-1271-4aac-8746-620d93c73b1e_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "d8785e68-1271-4aac-8746-620d93c73b1e_right": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_right"
    ]
  },
  "d8785e68-1271-4aac-8746-620d93c73b1e_top": {
    "is_pinned_to": [
      "ac2db977-a249-4092-9cdc-2e4893e64abd_bottom"
    ]
  },
  "d9e49dd8-5249-49af-9b1a-d4be5e2e9953": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_bottom",
      "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_left",
      "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_right",
      "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_top"
    ],
    "has_role": [
      "custom:title"
    ],
    "is_a": [
      "text"
    ]
  },
  "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_bottom": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom"
    ]
  },
  "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_right": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_right"
    ]
  },
  "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "deddf272-f102-4a15-851b-57b446f88245": {
    "has_axis": [
      "deddf272-f102-4a15-851b-57b446f88245_bottom",
      "deddf272-f102-4a15-851b-57b446f88245_left",
      "deddf272-f102-4a15-851b-57b446f88245_right",
      "deddf272-f102-4a15-851b-57b446f88245_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "deddf272-f102-4a15-851b-57b446f88245_bottom": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "deddf272-f102-4a15-851b-57b446f88245_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "deddf272-f102-4a15-851b-57b446f88245_right": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "deddf272-f102-4a15-851b-57b446f88245_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "df831973-eb26-469e-8d5a-019a40bece41": {
    "has_axis": [
      "df831973-eb26-469e-8d5a-019a40bece41_bottom",
      "df831973-eb26-469e-8d5a-019a40bece41_left",
      "df831973-eb26-469e-8d5a-019a40bece41_right",
      "df831973-eb26-469e-8d5a-019a40bece41_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "df831973-eb26-469e-8d5a-019a40bece41_bottom": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "df831973-eb26-469e-8d5a-019a40bece41_left": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "df831973-eb26-469e-8d5a-019a40bece41_right": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left"
    ]
  },
  "df831973-eb26-469e-8d5a-019a40bece41_top": {
    "is_pinned_to": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ]
  },
  "e00ca332-09bf-4da6-b1c4-31e1324b5b7f": {
    "has_axis": [
      "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_bottom",
      "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_left",
      "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_right",
      "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "e00ca332-09bf-4da6-b1c4-31e1324b5b7f_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "e0d1b09f-cf75-4bb3-b4ff-74debcfefd7b": {
    "has_attribute": [
      "text_auto_height"
    ],
    "is_a": [
      "text"
    ]
  },
  "e14cef1a-641e-4ea2-9516-ca9974f54082": {
    "has_axis": [
      "e14cef1a-641e-4ea2-9516-ca9974f54082_bottom",
      "e14cef1a-641e-4ea2-9516-ca9974f54082_left",
      "e14cef1a-641e-4ea2-9516-ca9974f54082_right",
      "e14cef1a-641e-4ea2-9516-ca9974f54082_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "e14cef1a-641e-4ea2-9516-ca9974f54082_bottom": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ]
  },
  "e14cef1a-641e-4ea2-9516-ca9974f54082_left": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left"
    ]
  },
  "e14cef1a-641e-4ea2-9516-ca9974f54082_right": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left"
    ]
  },
  "e14cef1a-641e-4ea2-9516-ca9974f54082_top": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ]
  },
  "e216c9a2-fb09-4e7e-9e84-c2b37c715cdf": {
    "has_accent_color": [
      "accent0:#EB1000",
      "accent1:#EB1000",
      "accent2:#EB1000"
    ],
    "has_primary_color": [
      "#000000"
    ],
    "has_secondary_color": [
      "#8821F4"
    ],
    "has_surface_color": [
      "#FFFFFF"
    ]
  },
  "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_bottom",
      "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_left",
      "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_right",
      "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_bottom": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_bottom"
    ]
  },
  "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_left": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_left"
    ]
  },
  "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_right": {
    "is_limited_by": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_right"
    ]
  },
  "e2d1c74c-4f57-4537-b5d5-2a1ee417ee08_top": {
    "is_pinned_to": [
      "8ca27b0f-d10e-4d35-912b-969e99e37aec_top"
    ]
  },
  "e75d149c-7ddd-4f4e-a151-14a59ea98ffb": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_bottom",
      "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_left",
      "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_right",
      "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_top"
    ],
    "has_role": [
      "content"
    ],
    "is_a": [
      "text"
    ]
  },
  "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_bottom": {
    "is_limited_by": [
      "083c6f6a-5f37-419d-947f-5f1aa0daae01_top_offset_-32"
    ]
  },
  "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_right": {
    "is_limited_by": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_right"
    ]
  },
  "e75d149c-7ddd-4f4e-a151-14a59ea98ffb_top": {
    "is_pinned_to": [
      "315f7ad5-00c2-4fbb-8239-836b86a53ecc_bottom"
    ]
  },
  "e87eb981-9025-4af3-8a9b-11525b18559d": {
    "has_axis": [
      "e87eb981-9025-4af3-8a9b-11525b18559d_bottom",
      "e87eb981-9025-4af3-8a9b-11525b18559d_left",
      "e87eb981-9025-4af3-8a9b-11525b18559d_right",
      "e87eb981-9025-4af3-8a9b-11525b18559d_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "e87eb981-9025-4af3-8a9b-11525b18559d_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "e87eb981-9025-4af3-8a9b-11525b18559d_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "e87eb981-9025-4af3-8a9b-11525b18559d_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "e87eb981-9025-4af3-8a9b-11525b18559d_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "eb669744-64d3-4171-9b10-3784d7cb8a94": {
    "contains": [
      "0892589a-e09d-4d9b-bb9e-f48a76b0553d",
      "18099207-fd29-41eb-b50c-266787682802",
      "3eeacefe-1c84-4637-b4a5-d988c4411b34",
      "419fda32-2472-49ec-80a7-8bdd6b504d70",
      "85f25280-8989-4be3-b16c-6e9d22d9b6c1",
      "9b6abe86-24f1-4829-9eb1-8b49293dc09b",
      "9c1f6c13-a362-42ef-907c-b9fec7b4041f",
      "a15c5b64-2636-47f3-8544-1ce6f29a62a7",
      "ad3af027-0fdb-40dd-99de-93a1cc60f8bd",
      "b1ce999b-d48a-4170-8b0f-13cc24f073c4",
      "c1cb59a2-1fbd-400d-95da-2139af7f464d",
      "df831973-eb26-469e-8d5a-019a40bece41"
    ],
    "has_axis": [
      "eb669744-64d3-4171-9b10-3784d7cb8a94_bottom",
      "eb669744-64d3-4171-9b10-3784d7cb8a94_left",
      "eb669744-64d3-4171-9b10-3784d7cb8a94_right",
      "eb669744-64d3-4171-9b10-3784d7cb8a94_top"
    ],
    "is_a": [
      "slide"
    ]
  },
  "ec9156be-f2e5-46c9-97b5-fe769bda3ed9": {
    "has_axis": [
      "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_bottom",
      "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_left",
      "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_right",
      "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "ec9156be-f2e5-46c9-97b5-fe769bda3ed9_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_bottom",
      "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_left",
      "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_right",
      "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_top"
    ],
    "has_role": [
      "custom:subtitle"
    ],
    "is_a": [
      "text"
    ]
  },
  "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_bottom": {
    "is_limited_by": [
      "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_top"
    ]
  },
  "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_right": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_right"
    ]
  },
  "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_top": {
    "is_pinned_to": [
      "d9e49dd8-5249-49af-9b1a-d4be5e2e9953_bottom"
    ]
  },
  "ecee4b97-e77a-4a46-9d81-e353eb45199b": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "ecee4b97-e77a-4a46-9d81-e353eb45199b_bottom",
      "ecee4b97-e77a-4a46-9d81-e353eb45199b_left",
      "ecee4b97-e77a-4a46-9d81-e353eb45199b_right",
      "ecee4b97-e77a-4a46-9d81-e353eb45199b_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "ecee4b97-e77a-4a46-9d81-e353eb45199b_bottom": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_bottom"
    ]
  },
  "ecee4b97-e77a-4a46-9d81-e353eb45199b_left": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "ecee4b97-e77a-4a46-9d81-e353eb45199b_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "ecee4b97-e77a-4a46-9d81-e353eb45199b_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "edde815a-a16e-4ca1-956d-494986896ef4": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "edde815a-a16e-4ca1-956d-494986896ef4_bottom",
      "edde815a-a16e-4ca1-956d-494986896ef4_left",
      "edde815a-a16e-4ca1-956d-494986896ef4_right",
      "edde815a-a16e-4ca1-956d-494986896ef4_top"
    ],
    "is_a": [
      "text"
    ]
  },
  "edde815a-a16e-4ca1-956d-494986896ef4_bottom": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom"
    ]
  },
  "edde815a-a16e-4ca1-956d-494986896ef4_left": {
    "is_limited_by": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "edde815a-a16e-4ca1-956d-494986896ef4_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "edde815a-a16e-4ca1-956d-494986896ef4_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "ee557a2e-b3e7-40ae-a78f-486bc1693d8f": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_bottom",
      "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_left",
      "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_right",
      "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "text"
    ]
  },
  "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_bottom": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_bottom"
    ]
  },
  "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_left": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_left"
    ]
  },
  "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_right": {
    "is_limited_by": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_right"
    ]
  },
  "ee557a2e-b3e7-40ae-a78f-486bc1693d8f_top": {
    "is_pinned_to": [
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418_top"
    ]
  },
  "ef87ed0b-1977-45e7-9ce9-2bb509ceceba": {
    "has_axis": [
      "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_bottom",
      "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_left",
      "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_right",
      "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "ef87ed0b-1977-45e7-9ce9-2bb509ceceba_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321": {
    "has_axis": [
      "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_bottom",
      "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_left",
      "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_right",
      "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_bottom": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_left": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_right": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_left"
    ]
  },
  "efe8bb7d-8a5f-42c1-bf5f-214f82eb1321_top": {
    "is_pinned_to": [
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82_top"
    ]
  },
  "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea": {
    "has_axis": [
      "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_bottom",
      "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_left",
      "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_right",
      "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_bottom": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ]
  },
  "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_left": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left"
    ]
  },
  "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_right": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_left"
    ]
  },
  "f06a5138-889a-4bab-83b0-3dcfeb5bf1ea_top": {
    "is_pinned_to": [
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f_top"
    ]
  },
  "f2161dbc-a064-46a0-aa86-4a848d9d3940": {
    "has_axis": [
      "f2161dbc-a064-46a0-aa86-4a848d9d3940_bottom",
      "f2161dbc-a064-46a0-aa86-4a848d9d3940_left",
      "f2161dbc-a064-46a0-aa86-4a848d9d3940_right",
      "f2161dbc-a064-46a0-aa86-4a848d9d3940_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "f2161dbc-a064-46a0-aa86-4a848d9d3940_bottom": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "f2161dbc-a064-46a0-aa86-4a848d9d3940_left": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "f2161dbc-a064-46a0-aa86-4a848d9d3940_right": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_left"
    ]
  },
  "f2161dbc-a064-46a0-aa86-4a848d9d3940_top": {
    "is_pinned_to": [
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11_top"
    ]
  },
  "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d": {
    "has_axis": [
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_bottom",
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_left",
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_right",
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top",
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top_offset_-32"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "image"
    ]
  },
  "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_bottom": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_right": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_top"
    ]
  },
  "f471ccc2-8071-4df9-907f-f30b1f5dced9": {
    "contains": [
      "152bfeb9-aa0c-42cf-b639-d3f63556df80",
      "3dcae55c-5ebc-4a46-a381-a98ef638bfb4",
      "4f18efff-7c4e-4636-8d01-032d5e4c7a73",
      "58d1cbba-5637-48a1-b003-c6c585a07cfe",
      "ac2db977-a249-4092-9cdc-2e4893e64abd",
      "b9a08d48-67d9-40b3-ad53-45a81895ab9b",
      "d8785e68-1271-4aac-8746-620d93c73b1e",
      "f70c3d13-1804-4a07-84cb-253584ca556c"
    ],
    "has_axis": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom",
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left",
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_right",
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ],
    "has_role": [
      "chapter"
    ],
    "is_a": [
      "slide"
    ]
  },
  "f70c3d13-1804-4a07-84cb-253584ca556c": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "f70c3d13-1804-4a07-84cb-253584ca556c_bottom",
      "f70c3d13-1804-4a07-84cb-253584ca556c_left",
      "f70c3d13-1804-4a07-84cb-253584ca556c_right",
      "f70c3d13-1804-4a07-84cb-253584ca556c_top"
    ],
    "has_role": [
      "context_title"
    ],
    "is_a": [
      "text"
    ]
  },
  "f70c3d13-1804-4a07-84cb-253584ca556c_bottom": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_bottom"
    ]
  },
  "f70c3d13-1804-4a07-84cb-253584ca556c_left": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_left"
    ]
  },
  "f70c3d13-1804-4a07-84cb-253584ca556c_right": {
    "is_limited_by": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_right"
    ]
  },
  "f70c3d13-1804-4a07-84cb-253584ca556c_top": {
    "is_pinned_to": [
      "f471ccc2-8071-4df9-907f-f30b1f5dced9_top"
    ]
  },
  "f73574b9-71e0-42e7-99ea-70a35fcf09f0": {
    "contains": [
      "03d15d0c-e7ae-4383-b942-bef5af32b9d2",
      "10110498-84dd-4eac-a05f-1d6a6786cc39",
      "40802aad-299d-45e9-8c97-099453c995f8",
      "65712f61-cfc5-4c4e-9563-b6ab2eab5902",
      "6929c343-70aa-4324-b590-5bfafd176df0",
      "69b7a4e4-a179-46e0-8576-8a861a67e156",
      "8a56399c-4fc2-4e72-a798-bd90aeb417c9",
      "bd369631-a068-494a-9084-0b4bdb7312f5",
      "c04a832d-36f6-400b-8fd5-fbff24acb317",
      "d0ca6162-f9ca-4447-ac12-6c28c6f63c3a",
      "e87eb981-9025-4af3-8a9b-11525b18559d",
      "edde815a-a16e-4ca1-956d-494986896ef4",
      "feb8b24a-4955-43d8-8699-a325d3acf61d"
    ],
    "has_axis": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_bottom",
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left",
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_right",
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ],
    "is_a": [
      "slide"
    ]
  },
  "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1": {
    "contains": [
      "2931e5d2-ce81-42e9-a4ad-66ddf0f449e6",
      "48f59b8a-ad78-4fbc-add6-9cb6a922c231",
      "506097e9-1862-4658-95e7-a9ce78273fca",
      "510134a1-8d81-4e98-8d68-0f5290eea590",
      "716445cb-1a99-4546-a262-990ce93f5b14",
      "7b210f71-5928-466e-aa4d-02ae284e2989",
      "825eca02-f797-4734-8db9-23a087f2ed2e",
      "b60587e5-64df-4c1c-849f-520a5a84c296",
      "bce10be2-b9a8-4cca-91f5-8d7dc3141009",
      "e0d1b09f-cf75-4bb3-b4ff-74debcfefd7b",
      "fed84f0e-4fa3-422a-9d65-c5ee63964554"
    ],
    "has_axis": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left",
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ],
    "is_a": [
      "slide"
    ]
  },
  "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5": {
    "has_attribute": [
      "text_auto_height"
    ],
    "has_axis": [
      "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_bottom",
      "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_left",
      "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_right",
      "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_top"
    ],
    "has_role": [
      "custom:content"
    ],
    "is_a": [
      "text"
    ]
  },
  "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_bottom": {
    "is_limited_by": [
      "f3122d6b-bd6b-4e7e-be22-0773ddcc1f8d_top_offset_-32"
    ]
  },
  "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_left": {
    "is_pinned_to": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_left"
    ]
  },
  "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_right": {
    "is_limited_by": [
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7_right"
    ]
  },
  "fbdd86e8-dfc5-47e8-bc2d-6aaa250985e5_top": {
    "is_pinned_to": [
      "ecb0bb72-1fa7-48f6-89f4-dc8d3f0f7871_bottom"
    ]
  },
  "fccda08f-b71b-4661-bdbd-157f12aca817": {
    "has_axis": [
      "fccda08f-b71b-4661-bdbd-157f12aca817_bottom",
      "fccda08f-b71b-4661-bdbd-157f12aca817_left",
      "fccda08f-b71b-4661-bdbd-157f12aca817_right",
      "fccda08f-b71b-4661-bdbd-157f12aca817_top"
    ],
    "has_role": [
      "decoration"
    ],
    "is_a": [
      "shape"
    ]
  },
  "fccda08f-b71b-4661-bdbd-157f12aca817_bottom": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "fccda08f-b71b-4661-bdbd-157f12aca817_left": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "fccda08f-b71b-4661-bdbd-157f12aca817_right": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_left"
    ]
  },
  "fccda08f-b71b-4661-bdbd-157f12aca817_top": {
    "is_pinned_to": [
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e_top"
    ]
  },
  "feb8b24a-4955-43d8-8699-a325d3acf61d": {
    "has_axis": [
      "feb8b24a-4955-43d8-8699-a325d3acf61d_bottom",
      "feb8b24a-4955-43d8-8699-a325d3acf61d_left",
      "feb8b24a-4955-43d8-8699-a325d3acf61d_right",
      "feb8b24a-4955-43d8-8699-a325d3acf61d_top"
    ],
    "is_a": [
      "image"
    ]
  },
  "feb8b24a-4955-43d8-8699-a325d3acf61d_bottom": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "feb8b24a-4955-43d8-8699-a325d3acf61d_left": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "feb8b24a-4955-43d8-8699-a325d3acf61d_right": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_left"
    ]
  },
  "feb8b24a-4955-43d8-8699-a325d3acf61d_top": {
    "is_pinned_to": [
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0_top"
    ]
  },
  "fed84f0e-4fa3-422a-9d65-c5ee63964554": {
    "has_axis": [
      "fed84f0e-4fa3-422a-9d65-c5ee63964554_bottom",
      "fed84f0e-4fa3-422a-9d65-c5ee63964554_left",
      "fed84f0e-4fa3-422a-9d65-c5ee63964554_right",
      "fed84f0e-4fa3-422a-9d65-c5ee63964554_top"
    ],
    "is_a": [
      "shape"
    ]
  },
  "fed84f0e-4fa3-422a-9d65-c5ee63964554_bottom": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ]
  },
  "fed84f0e-4fa3-422a-9d65-c5ee63964554_left": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left"
    ]
  },
  "fed84f0e-4fa3-422a-9d65-c5ee63964554_right": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_left"
    ]
  },
  "fed84f0e-4fa3-422a-9d65-c5ee63964554_top": {
    "is_pinned_to": [
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1_top"
    ]
  },
  "root": {
    "contains": [
      "32fd34ec-3db9-4c63-98c8-f6edeb97505b",
      "3c566718-4899-439f-bac4-3c58a81f1aa7",
      "64358dd5-ae6a-4b59-9d2d-1b051def1d82",
      "6d4b04b8-5837-45fa-a49f-0d6a15e4348e",
      "731d57c9-7588-4ca3-a019-5618a436794a",
      "8ca27b0f-d10e-4d35-912b-969e99e37aec",
      "9b62394d-e882-4b32-8673-9a6663063d0f",
      "9cc1b7db-35bb-4ad1-b4f2-47943e535418",
      "9ea59f27-7ca5-47b3-aab2-727a7de631f7",
      "af8ab741-e916-43d1-9956-e1d0ab5d3a2f",
      "c39209f9-2bd4-4052-9c3c-5e18c5be0d11",
      "eb669744-64d3-4171-9b10-3784d7cb8a94",
      "f471ccc2-8071-4df9-907f-f30b1f5dced9",
      "f73574b9-71e0-42e7-99ea-70a35fcf09f0",
      "f9276da5-d611-4f2c-a2f0-96f7d79b4ed1"
    ],
    "has_theme": [
      "e216c9a2-fb09-4e7e-9e84-c2b37c715cdf"
    ],
    "is_a": [
      "presentation"
    ]
  }
}